const getMovies = () => {
  return [
    "오징어게임",
    "부산행",
    "공조",
    "백두산",
    "국제시장",
    "감시자들",
    "쉬리",
    "밀정",
    "알라딘",
    "기생충",
    "태극기휘날리며",
    "히말라야",
    "다크나이트",
    "내부자들",
    "실미도",
    "사도",
    "닥터스트레인지",
    "레미제라블",
    "덕혜옹주",
    "왕의남자",
    "베를린",
    "연평해전",
    "베테랑",
    "트랜스포머",
    "해적",
    "검사외전",
    "광해,왕이된남자",
    "관상",
    "설국열차",
    "타짜",
    "아이언맨",
    "써니",
    "쥬라기월드",
    "럭키",
    "청년경찰",
    "괴물",
    "범죄도시",
    "과속스캔들",
    "늑대소년",
    "군함도",
    "탑건",
    "아저씨",
    "해운대",
    "신과함께",
    "2012",
    "변호인",
    "디워",
    "의형제",
    "화려한휴가",
    "7번방의선물",
    "숨바꼭질",
    "투사부일체",
    "1987",
    "곡성",
    "반지의제왕",
    "미션임파서블",
    "보헤미안랩소디",
    "좋은놈,나쁜놈,이상한놈",
    "암살",
    "어벤져스",
    "캡틴아메리카",
    "수상한그녀",
    "인터스텔라",
    "전우치",
    "스파이더맨",
    "캡틴마블",
    "도둑들",
    "인셉션",
    "더테러라이브",
    "아바타",
    "웰컴투동막골",
    "국가대표",
    "앤트맨과와스프",
    "택시운전사",
    "명량",
    "겨울왕국",
    "최종병기활",
    "엑시트",
    "터널",
    "미녀는괴로워",
    "극한직업",
    "킹스맨",
    "은밀하게위대하게",
    "마스터",
    "인천상륙작전"
  ];
};

const getProverbs = () => {
  return [
    "달면 삼키고 쓰면 뱉는다",
    "닭 잡아 먹고 오리발 내민다",
    "땅 짚고 헤엄치기",
    "남의 잔치에 감 놓아라 배 놓아라 한다",
    "쇠뿔도 단김에 빼랬다",
    "서당 개 삼 년에 풍월을 읊는다",
    "원수는 외나무 다리에서 만난다",
    "보기 좋은 떡이 먹기도 좋다",
    "좋은 약은 입에 쓰다",
    "사공이 많으면 배가 산으로 올라간다",
    "못된 송아지 엉덩이에 뿔 난다",
    "식은 죽 먹기",
    "바늘 도둑이 소 도둑 된다",
    "하늘의 별 따기",
    "한 귀로 듣고 한 귀로 흘린다",
    "믿는 도끼에 발등 찍힌다",
    "꿩 먹고 알 먹기",
    "뛰는 놈 위에 나는 놈 있다",
    "가재는 게 편이라",
    "개밥에 도토리",
    "호랑이도 제 말 하면 온다",
    "소 잃고 외양간 고친다",
    "까마귀 날자 배 떨어진다",
    "개구리 올챙이 적 생각을 못한다",
    "벼룩의 간 빼먹기",
    "우물에 가서 숭늉 찾는다",
    "꿩 대신 닭",
    "수박 겉 핥기",
    "약방에 감초",
    "백지장도 맞들면 낫다",
    "어물전 망신은 꼴뚜기가 시킨다",
    "가지 많은 나무에 바람 잘 날 없다",
    "병 주고 약 준다",
    "열 번 찍어 아니 넘어가는 나무 없다",
    "등잔 밑이 어둡다",
    "구더기 무서워 장 못 담글까",
    "낫 놓고 기역자도 모른다",
    "목구멍이 포도청",
    "울며 겨자 먹기",
    "옥의 티",
    "작은 고추가 더 맵다",
    "도둑이 제 발 저리다",
    "되로 주고 말로 받는다",
    "값싼 것이 비지떡",
    "아니 땐 굴뚝에 연기 나랴",
    "아닌 밤중에 홍두깨",
    "구슬이 서 말이라도 꿰어야 보배라",
    "같은 값이면 다홍치마",
    "핑계 없는 무덤 없다",
    "그림의 떡",
    "낮말은 새가 듣고 밤말은 쥐가 듣는다",
    "하룻강아지 범 무서운 줄 모른다",
    "아는 길도 물어 가라",
    "원숭이도 나무에서 떨어진다",
    "고양이 목에 방울 달기",
    "배보다 배꼽이 더 크다",
    "오르지 못할 나무는 쳐다보지도 말아라",
    "빛 좋은 개살구",
    "금강산도 식후경",
    "티끌 모아 태산",
    "자라 보고 놀란 가슴 솥뚜껑 보고 놀란다",
    "똥 묻은 개가 겨 묻은 개 나무란다",
    "십 년이면 강산도 변한다",
    "마른 하늘에 날벼락",
    "한 술 밥에 배 부르랴",
    "공든 탑이 무너지랴",
    "세 살 버릇 여든까지 간다",
    "콩 심은 데 콩 나고 팥 심은 데 팥 난다",
    "가는 날이 장날이다",
    "밑 빠진 독에 물 붓기",
    "가는 말이 고와야 오는 말이 곱다",
    "늦게 배운 도둑이 날 새는 줄 모른다",
    "종로에서 뺨 맞고 한강 가서 눈 흘긴다",
    "천 리 길도 한 걸음부터",
    "쥐구멍에도 볕 들 날이 있다",
    "가랑비에 옷 젖는 줄 모른다",
    "소문난 잔치에 먹을 것 없다",
    "누워서 침 뱉기",
    "내 코가 석 자",
    "개천에서 용 난다",
    "고기는 씹어야 맛이요, 말은 해야 맛이라",
    "지렁이도 밟으면 꿈틀한다",
    "윗물이 맑아야 아랫물도 맑다",
    "하늘이 무너져도 솟아날 구멍이 있다",
    "간에 기별도 안 간다",
    "귀에 걸면 귀걸이, 코에 걸면 코걸이",
    "칼로 물 베기",
    "고래 싸움에 새우 등 터진다",
    "다 된 죽에 코 풀기",
    "열 길 물 속은 알아도 한 길 사람 속은 모른다",
    "갈수록 태산",
    "말 한마디에 천 냥 빚도 갚는다",
    "돌다리도 두들겨 보고 건너라"
  ];
};

const getAnimals = () => {
  return [
    "치타",
    "부엉이",
    "소",
    "올뺴미",
    "개",
    "사슴",
    "산양",
    "도마뱀",
    "아르마딜로",
    "캥거루",
    "오랑우탄",
    "두더지",
    "타조",
    "하이에나",
    "개미핥기",
    "나무늘보",
    "호랑이",
    "앵무새",
    "코끼리",
    "곰",
    "기린",
    "여우",
    "악어",
    "판다",
    "용",
    "두꺼비",
    "공작",
    "홍학",
    "독수리",
    "수달",
    "코뿔소",
    "하마",
    "고양이",
    "염소",
    "미어캣",
    "코알라",
    "돼지",
    "뱀",
    "고릴라",
    "거북이",
    "개구리",
    "원숭이",
    "침팬지",
    "양",
    "쥐",
    "토끼",
    "말",
    "닭",
    "사자",
    "낙타"
  ];
};

export { getMovies, getProverbs, getAnimals };
